module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-400-regular-italic-2079bd1208565096864b05d01345c62d.woff2";